import { createAction } from 'redux-actions';

export const PRODUCT_FOLDER_ID_SET = 'PRODUCT_FOLDER_ID_SET';

export default createAction(PRODUCT_FOLDER_ID_SET);
